module.exports = "https://img1.huilianyi.com/9/icon-hand.952c63aa27.appcore.png";